import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CheckBox from '../checkBox/CheckBox';
import styles from './participatingOrgItem.module.scss';

const ParticipatingOrgItem = props => {
  const dispatch = useDispatch();

  const getLink = o => {
    return o.moreDetails.indexOf('href=') > -1 && o.moreDetails.indexOf('target') > -1
      ? o.moreDetails.substring(
          o.moreDetails.indexOf('href=') + 6,
          o.moreDetails.indexOf('target') - 2
        )
      : null;
  };

  const getSelectedCategoryCount = category => {
    return props.selectedNotifiableOrganisations.filter(v => v.category === category).length || 0;
  };

  return (
    <div className={styles.accordionContainer} key={props.category}>
      <div
        tabindex="0"
        onClick={() => props.onHeaderClick(props.index)}
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.onHeaderClick(props.index);
          }
        }}
        className={`${styles.catHeader} ${props.openIndex ? styles.expanded : styles.collapsed}`}
      >
        {!props.openIndex ? (
          <span className={`${styles.chevron} ${styles.bottom}`} />
        ) : (
          <span className={`${styles.chevron} ${styles.top}`} />
        )}
        {props.category}
        {props.selectionEnabled && getSelectedCategoryCount(props.category) > 0 ? (
          <span className={styles.selectedCount}>
            {' '}
            &nbsp;({getSelectedCategoryCount(props.category)})
          </span>
        ) : null}
      </div>
      {props.openIndex ? (
        <div>
          {props.categoryArray.map(item => (
            <div className={styles.checkboxContainer}>
              <div className={`d-flex ${styles.orgLogo}`}>
                {props.selectionEnabled ? (
                  <div className={styles.checkboxItem}>
                    <CheckBox
                      id={item.displayName}
                      name={item.displayName}
                      label={``}
                      type="checkbox"
                      value={false}
                      checked={props.selectedNotifiableOrganisations.some(
                        v => v.label === item.displayName
                      )}
                      onChange={() => {
                        let newSelectedOrgs = props.selectedNotifiableOrganisations.concat({
                          value: item.orgId,
                          label: item.displayName,
                          category: item.category,
                          orderByCategory: item.orderByCategory,
                          sector: item.sector,
                          logo: item.logo,
                          policyNumber: item.orgReferenceList ? [''] : [],
                          orgReferenceList: item.orgReferenceList,
                        });
                        const isSelected = props.selectedNotifiableOrganisations.find(
                          sv => sv.value === item.orgId
                        );
                        if (isSelected) {
                          newSelectedOrgs = props.selectedNotifiableOrganisations.filter(
                            sv => sv.value !== item.orgId
                          );
                        }

                        props.clearError('participatingOrganisations');
                        props.setSelectedOrganisations(newSelectedOrgs);
                        dispatch(
                          props.setIsAwareSubsidiaryShown(
                            props.filterIsAwareSuperSubsidiariesSelected(newSelectedOrgs)
                          )
                        );
                      }}
                    />
                  </div>
                ) : null}
                <div className={styles.logoWrap}>
                  <img src={item.logo} alt="logo" />
                </div>
                <a className={styles.imageDesc} href={getLink(item)} target="_blank" translate="no">
                  {item.displayName}
                </a>
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ParticipatingOrgItem;
